import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { motion } from 'framer-motion';

export const InfoSec = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  min-height: 100vh;
  padding: 140px 0 100px;
  z-index: 10;
  overflow: hidden;
  position: relative !important;
  background:
    radial-gradient(circle at 78% 28%, ${(props) => props.theme.text}22 0%, transparent 42%),
    radial-gradient(circle at 12% 85%, ${(props) => props.theme.text}14 0%, transparent 40%),
    #050505;

  @media screen and (max-width: 768px) {
    padding: 120px 0 80px;
    min-height: auto;
  }
`;

export const InfoRow = styled.div`
  z-index: 2;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 50px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
  flex-direction: ${({ imgStart }) => (imgStart ? 'row-reverse' : 'row')};

  @media screen and (max-width: 991px) {
    padding: 0 30px;
  }
  @media screen and (max-width: 880px) {
    flex-direction: column-reverse;
    text-align: center;
    gap: 48px;
  }
`;

export const InfoColumn = styled.div`
  flex: 1;
  min-width: 300px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 880px) {
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  max-width: 600px;
  width: 100%;

  @media screen and (max-width: 880px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

/* Glass status pill: "Available for new opportunities" */
export const StatusPill = styled(motion.div)`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 8px 16px;
  margin-bottom: 26px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: #e9edf5;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  backdrop-filter: blur(10px);

  span.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => props.theme.text};
    box-shadow: 0 0 0 4px ${(props) => props.theme.text}33;
    animation: pulseDot 2s ease-in-out infinite;
  }

  @keyframes pulseDot {
    0%, 100% { box-shadow: 0 0 0 0 ${(props) => props.theme.text}55; }
    50% { box-shadow: 0 0 0 6px ${(props) => props.theme.text}11; }
  }
`;

export const TopLine = styled.div`
  color: ${(props) => props.theme.text};
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 14px;
`;

export const Greeting = styled(motion.h1)`
  font-size: 26px;
  font-weight: 500;
  color: #aab2c0;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 10px;
`;

export const Hello = styled.span`
  font-family: 'Poppins', sans-serif;
  color: ${(props) => props.theme.text} !important;
`;

/* Wrapper that keeps the animated signature SVG sizing modern */
export const NameWrap = styled(motion.div)`
  margin-bottom: 20px;
  overflow: hidden;

  svg {
    height: 64px;
    width: auto;
    filter: drop-shadow(0 4px 24px ${(props) => props.theme.text}33);
  }
  svg + svg {
    margin-left: 6px;
  }

  @media screen and (max-width: 560px) {
    svg { height: 46px; }
  }
`;

export const Typing = styled(motion.p)`
  color: #cbd2de;
  max-width: 520px;
  margin-bottom: 14px;
  font-size: 30px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  line-height: 1.3;

  @media screen and (max-width: 945px) {
    font-size: 24px;
  }
  @media screen and (max-width: 450px) {
    font-size: 20px;
  }
`;

export const TypedM = styled(motion.span)`
  color: ${(props) => props.theme.text};
  font-weight: 700;
  ::-moz-selection { background: ${(props) => props.theme.text}; color: #000; }
  ::selection { background: ${(props) => props.theme.text}; color: #000; }
`;

export const TagLine = styled(motion.p)`
  color: #8b94a3;
  max-width: 480px;
  font-size: 17px;
  line-height: 1.65;
  margin-bottom: 34px;

  @media screen and (max-width: 450px) {
    font-size: 15px;
  }
`;

export const CtaRow = styled(motion.div)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 30px;

  @media screen and (max-width: 880px) {
    justify-content: center;
  }
`;

export const Button = styled(LinkS)`
  background: ${(props) => props.theme.text};
  padding: 13px 32px;
  color: #050505;
  font-size: 16px;
  font-weight: 700;
  outline: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  white-space: nowrap;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 10px 30px -10px ${(props) => props.theme.text}99;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 40px -12px ${(props) => props.theme.text};
  }
`;

export const GhostButton = styled.a`
  padding: 13px 26px;
  color: #e9edf5;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.14);
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.text};
    color: ${(props) => props.theme.text};
    transform: translateY(-2px);
  }
`;

export const SocialRow = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 26px;

  @media screen and (max-width: 880px) {
    justify-content: center;
  }
`;

export const SocialLink = styled.a`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: #c4ccd8;
  font-size: 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.text};
    border-color: ${(props) => props.theme.text};
    transform: translateY(-3px);
  }
`;

/* ---- Theme color switcher (kept) ---- */
export const Buttons = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 14px;

  @media screen and (max-width: 880px) {
    justify-content: center;
  }
`;

export const ColorLabel = styled.span`
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #6b7280;
  margin-right: 4px;
`;

export const Toggle = styled(motion.div)`
  border-radius: 50%;
  width: 1.1rem;
  height: 1.1rem;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: scale(1.4);
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.1);
  }
`;

/* ---- Image side ---- */
export const ImgWrapper = styled(motion.div)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImgFrame = styled.div`
  position: relative;
  width: 380px;
  height: 460px;
  border-radius: 28px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px -30px ${(props) => props.theme.text}aa;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 55%, rgba(5, 5, 5, 0.55) 100%);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media screen and (max-width: 560px) {
    width: 280px;
    height: 350px;
  }
`;

export const Glow = styled.div`
  position: absolute;
  inset: -40px;
  border-radius: 50%;
  background: radial-gradient(circle, ${(props) => props.theme.text}40 0%, transparent 65%);
  filter: blur(30px);
  z-index: -1;
`;

export const FloatBadge = styled(motion.div)`
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 12px 18px;
  border-radius: 16px;
  background: rgba(15, 15, 18, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(12px);
  box-shadow: 0 16px 40px -16px rgba(0, 0, 0, 0.8);

  strong {
    font-size: 20px;
    color: ${(props) => props.theme.text};
    line-height: 1.1;
  }
  span {
    font-size: 12px;
    color: #aab2c0;
    margin-top: 2px;
    white-space: nowrap;
  }

  &.top {
    top: 26px;
    left: -34px;
  }
  &.bottom {
    bottom: 30px;
    right: -30px;
  }

  @media screen and (max-width: 560px) {
    &.top { left: -10px; }
    &.bottom { right: -8px; }
  }
`;

export const ScrollCue = styled(LinkS)`
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: none;

  &:hover { color: ${(props) => props.theme.text}; }

  .mouse {
    width: 22px;
    height: 36px;
    border: 2px solid currentColor;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    padding-top: 6px;
  }
  .wheel {
    width: 3px;
    height: 7px;
    border-radius: 2px;
    background: currentColor;
    animation: scrollWheel 1.6s ease-in-out infinite;
  }
  @keyframes scrollWheel {
    0% { opacity: 0; transform: translateY(-4px); }
    40% { opacity: 1; }
    100% { opacity: 0; transform: translateY(8px); }
  }

  @media screen and (max-width: 880px) { display: none; }
`;
